import { render, staticRenderFns } from "./Encabezados.vue?vue&type=template&id=62864832"
import script from "./Encabezados.vue?vue&type=script&lang=js"
export * from "./Encabezados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports